import { CustomFieldListItemProps } from "@/components/custom-field/list-item/custom-field-list-item.type.ts";
import { ListItem, SelectItem } from "@skailer-com/uikit";

export function CustomFieldListItemSelect({
  field,
  fieldValue,
  options,
  label,
}: CustomFieldListItemProps) {
  let optionsInner: SelectItem[] | undefined = undefined;
  if (fieldValue?.value_int_array) {
    optionsInner = options?.filter(
      (option) => option.id && fieldValue?.value_int_array?.includes(Number(option.id))
    );
  }
  const title = optionsInner?.map((option) => option.title).join(", ") ?? "-";
  return <ListItem preTitle={label ?? field.title} title={title} />;
}
